import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import AIChatClient from "./components/AIChatClient/AIChatClient";

const root = document.getElementById("justask");
const {
	assistantId,
	vectorStoreId,
	siteName,
	siteTopics,
	assistantPersonality,
	title,
	titleImageUrl,
	welcomeHtml,
	promptSuggestions,
	autolinkText,
	proxyUrl,
	captchaRequired,
	captchaSiteKey,
	gtmContainerId,
	utmSource,
	utmMedium,
	utmCampaign,
	initialNonce,
	themeConf,
} = root!.dataset;

if (gtmContainerId) {
	TagManager.initialize({
		gtmId: gtmContainerId,
	});
}

ReactDOM.createRoot(root!).render(
	<AIChatClient
		assistantID={assistantId!}
		vectorStoreId={vectorStoreId!}
		siteName={siteName!}
		siteTopics={siteTopics!}
		assistantPersonality={assistantPersonality!}
		appTitle={title!}
		appTitleImageURL={titleImageUrl!}
		welcomeHTML={welcomeHtml!}
		promptSuggestions={JSON.parse(promptSuggestions!)}
		autolinkText={JSON.parse(autolinkText!)}
		proxyURL={proxyUrl!}
		captchaRequired={Boolean(captchaRequired!)}
		captchaSiteKey={String(captchaSiteKey!)}
		utmSource={utmSource!}
		utmMedium={utmMedium!}
		utmCampaign={utmCampaign!}
		initialNonce={initialNonce!}
		themeConf={JSON.parse(themeConf!)}
	/>,
);
